import {
	Component,
	ElementRef,
	Inject,
	Input,
	LOCALE_ID,
	OnChanges,
	OnDestroy,
	OnInit,
	SimpleChanges,
	ViewChild
} from '@angular/core';
import {ErrorPage, ErrorPageService} from '@shared/service/error-page.service';
import {Subscription} from 'rxjs/Subscription';
import {DateUtilities} from '@shared/utilities/date-utilities.model';
import {AddToHomeDialogComponent} from '@shared/components/add-to-home-dialog/add-to-home-dialog.component';
import {Utilities} from '@shared/utilities/utilities.model';
import {LoaderService} from '@shared/service/loader.service';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {WizardSteps} from '@shared/models/wizard-steps.model';
import {MatSidenav} from '@angular/material/sidenav';
import {WizardService} from '@shared/service/wizard.service';
import {SearchDialogComponent} from '@shared/components/search-dialog/search-dialog.component';
import {ItemMenu} from '@shared/models/item-menu.model';
import {NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router} from '@angular/router';
import {LogoutDialogComponent} from '../logout-dialog/logout-dialog.component';
import {Location} from '@angular/common';
import $ from 'jquery/dist/jquery.min.js';
import bodymovin from 'bodymovin/build/player/bodymovin_light.min.js';
import {InnerMessagesService} from '@shared/service/inner-messages.service';
import {
	FIND_CENTERS_DASHBOARD,
	ROOT_ADMINISTRATION_CHANNELING,
	ROOT_ADMINISTRATION_RULES,
	ROOT_ADMINISTRATION_USER_MANAGEMENT,
	ROOT_AUTHORITY,
	ROOT_CLAIMS_ADMIN,
	ROOT_CLAIMS_APPROPRIATION,
	ROOT_CLAIMS_COMPLAINT,
	ROOT_CLAIMS_OLSA,
	ROOT_CLAIMS_PRACTICE_CAR,
	ROOT_CLAIMS_PRACTICES,
	ROOT_CLAIMS_REPAIR,
	ROOT_CLAIMS_SUPERVISOR,
	ROOT_CLAIMS_THEFT,
	ROOT_CONTRACT_CLOSING_ALD,
	ROOT_CONTRACT_CLOSING_DK_BO,
	ROOT_CONTRACT_CLOSING_DK_C,
	ROOT_CONTRACT_CLOSING_DK_OP,
	ROOT_CONTRACT_CLOSING_SP,
	ROOT_DELIVERY,
	ROOT_DELIVERY_ASR,
	ROOT_DIGITAL_SIGN,
	ROOT_BOOKINGS,
	ROOT_BOOKINGS_RELIEF,
	ROOT_BOOKINGS_PRELEASE,
	ROOT_INVOICING,
	ROOT_LOGISTICS,
	ROOT_NOT_FOUND_PAGE,
	ROOT_NOTIFICATION_CENTER,
	ROOT_PROFILE,
	ROOT_TYRES,
	ROOT_USER_CHANGE_ALD,
	ROOT_USER_CHANGE_SP,
	ROOT_VERSION,
	ROOT_FLOTTA_POOL,
	ROOT_MOBILITY
} from '../../../app-routing-roots';
import {PermissionService} from '@shared/service/permission.service';
import {CommodityModel} from '@shared/models/commodity.model';
import {UserV3CustomDataModel, UserV3Model} from '@shared/models/user-v-3.model';
import {UserV3Service} from '@shared/service/user-v-3.service';
import {DeviceDetectorService, DeviceInfo} from 'ngx-device-detector';
import {AppConfigEnvironmentService} from '@shared/service/appconfig-environment.service';
import {AppConfigEnvironment} from '@shared/models/appconfig-environment.model';
import {TYRES_OPA, TYRES_OPC, TYRES_OPF, TYRES_OPS} from '../../../tyres/tyres-routing-roots';
import {UC_SIGN} from 'app/user-change/user-change-routing-roots';
import {
	AUTHORITY_APPOINTMENTS_LIST,
	AUTHORITY_DASHBOARD,
	AUTHORITY_DOSSIER_LIST,
	AUTHORITY_DOSSIER_SIGN,
	AUTHORITY_DOSSIER_WORKING_LIST,
} from '../../../authority/authority-routing-roots';
import {ConstantsService} from 'app/authority/authority-shared/services/constants.service';
import {
	LOGISTICS_OPAD,
	LOGISTICS_OPASR,
	LOGISTICS_OPC,
	LOGISTICS_OPL
} from '../../../logistics/logistics-routing-roots';
import {take} from 'rxjs/operators';
import {MyaldMetadata} from '../../../claims/claims-driver/components/claims-driver-myald-redirect/claims-driver-myald-redirect.component';
import {INVOICING_DASHBOARD, INVOICING_INVOICES, INVOICING_TASKS} from '../../../invoicing/invoicing-routing-roots';
import {CrossPermissionModel, NemoModuleKeys, ProfilePermissionModel, UserPermissionsModel} from '@shared/models/user-permission.model';
import {PositiveThemeService} from '@shared/service/positive-theme.service';
import {ThreadService} from '../../../notification-center/services/thread.service';
import {CLAIMS_CUSTOM_ADMIN_PROFILES, CROSS_PERMISSION_NOTIFICATION_READER, MOBILITY_MYMOBILITY_PROFILE_USER, SuperUserPermissions} from '../../../permissions-variables';
import {NCStatsFilter} from '../../../notification-center/models/nc-stats-filter.model';
import {InPageMessage, InPageMessageSize, InPageMessageType} from '@shared/components/in-page-message/in-page-message.component';
import {Module, ModuleService} from '@shared/service/module.service';
import {TYRES_OPC_CONTRACT_DETAIL, TYRES_OPC_CONTRACTS, TYRES_OPC_DASHBOARD, TYRES_OPC_TYRE_DETAIL, TYRES_OPC_TYRES} from '../../../tyres/opc/tyres-opc-routing-roots';
import {BookingsRoutingRoots} from '../../../bookings/bookings-routing-roots';
import {NotificationsService} from '../../../notification-center/services/notifications.service';
import {get_current_item_menu_id, is_valid_route} from '@shared/utilities/utilities-function';
import { CommoditiesUtilityService } from '@shared/service/commodities-utility.service';
import {TranslateContext, TranslatePipe} from '@shared/pipes/translate.pipe';
import { UserUtilitiesModel } from '@shared/utilities/user-utilities.model';
import { MOBILITY_DASHBOARD, MOBILITY_DOSSIER_WORKING_LIST } from '@app/mobility/mobility-roots';

const introJs: any = require('intro.js/intro.js');

interface LogoParams {
	container: any;
	renderer: string;
	loop: boolean;
	autoplay: boolean;
	path: string;
}

@Component({
	selector: 'amd-core',
	templateUrl: './core.component.html',
	styleUrls: ['./core.component.scss']
})
export class CoreComponent implements OnDestroy, OnChanges, OnInit {
	static ACADEMY: any = 'academy';
	version: string = require('../../../../../package.json').version;
	ANIMATION_TIME: number = 1070;
	environmentLocation: string;
	environment: AppConfigEnvironment;

	intro: any;
	isFirstLogin: boolean;
	deviceInfo: DeviceInfo = null;
	currentErrorPage: ErrorPage = null;
	enableSearch: boolean;
	deliveryItemMenuID: string = UserV3Model.DELIVERY_ITEM_MENU_ID;
	deliveryAsrItemMenuID: string = UserV3Model.DELIVERY_ASR_ITEM_MENU_ID;
	profileItemMenuID: string = UserV3Model.PROFILE_ITEM_MENU_ID;
	contractClosingSpOpItemMenuID: string = UserV3Model.CONTRACT_CLOSING_SP_OP_ITEM_MENU_ID;
	contractClosingDkOpItemMenuID: string = UserV3Model.CONTRACT_CLOSING_DK_OP_ITEM_MENU_ID;
	contractClosingAldOpItemMenuID: string = UserV3Model.CONTRACT_CLOSING_ALD_OP_ITEM_MENU_ID;
	contractClosingBoOpItemMenuID: string = UserV3Model.CONTRACT_CLOSING_DK_BO_OP_ITEM_MENU_ID;
	contractClosingDkCItemMenuID: string = UserV3Model.CONTRACT_CLOSING_DK_C_ITEM_MENU_ID;
	notificationCenterItemMenuID: string = UserV3Model.NOTIFICATION_CENTER_ITEM_MENU_ID;
	authorityItemMenuID: string = UserV3Model.AUTHORITY_ITEM_MENU_ID;
	tyresItemOpcMenuID: string = UserV3Model.TYRES_ITEM_OPC_MENU_ID;
	tyresItemOpaMenuID: string = UserV3Model.TYRES_ITEM_OPA_MENU_ID;
	tyresItemOpfMenuID: string = UserV3Model.TYRES_ITEM_OPF_MENU_ID;
	tyresItemOpsMenuID: string = UserV3Model.TYRES_ITEM_OPS_MENU_ID;
	logisticsItemOplMenuID: string = UserV3Model.LOGISTICS_ITEM_OPL_MENU_ID;
	logisticsItemOpcMenuID: string = UserV3Model.LOGISTICS_ITEM_OPC_MENU_ID;
	logisticsItemOpadMenuID: string = UserV3Model.LOGISTICS_ITEM_OPAD_MENU_ID;
	logisticsItemOpasrMenuID: string = UserV3Model.LOGISTICS_ITEM_OPASR_MENU_ID;
	notFoundItemMenuID: string = UserV3Model.NOT_FOUND_ITEM_MENU_ID;
	claimsAdminItemMenuID: string = UserV3Model.CLAIMS_ADMIN_ITEM_MENU_ID;
	claimsSuperVisorItemMenuID: string = UserV3Model.CLAIMS_SUPERVISOR_ITEM_MENU_ID;
	claimsOlsaItemMenuID: string = UserV3Model.CLAIMS_OLSA_ITEM_MENU_ID;
	claimsRepairItemMenuID: string = UserV3Model.CLAIMS_REPAIR_ITEM_MENU_ID;
	claimsAppropriationItemMenuID: string = UserV3Model.CLAIMS_APPROPRIATION_ITEM_MENU_ID;
	claimsPracticeCarItemMenuID: string = UserV3Model.CLAIMS_PRACTICE_CAR_ITEM_MENU_ID;
	claimsPracticesItemMenuID: string = UserV3Model.CLAIMS_PRACTICES_ITEM_MENU_ID;
	claimsComplaintItemMenuID: string = UserV3Model.CLAIMS_COMPLAINT_ITEM_MENU_ID;
	claimsTheftItemMenuID: string = UserV3Model.CLAIMS_THEFT_ITEM_MENU_ID;
	invocingItemMenuID: string = UserV3Model.INVOICING_ITEM_MENU_ID;

	userChangeSpMenuID: string = UserV3Model.USER_CHANGE_SP_MENU_ID;
	userChangeAldMenuID: string = UserV3Model.USER_CHANGE_ALD_MENU_ID;
	// administrationSAItemMenuID: string = UserV3Model.ADMINISTRATION_SA_MENU_ID;

	administrationRulesItemMenuID: string = UserV3Model.ADMINISTRATION_RULES_MENU_ID;
	administrationChannelingItemMenuID: string = UserV3Model.ADMINISTRATION_CHANNELING_MENU_ID;
	administrationUserMItemMenuID: string = UserV3Model.ADMINISTRATION_USERS_MENU_ID;

	flottaPoolItemMenuID: string = UserV3Model.FLOTTA_POOL_MENU_ID;
	bookingsReliefItemMenuID: string = UserV3Model.BOOKINGS_RELIEF_MENU_ID;
	bookingsPreleaseItemMenuID: string = UserV3Model.BOOKINGS_PRELEASE_MENU_ID;

	isSidenavClosed: boolean = true;
	isMenuWrapperClosed: boolean = true;

	@ViewChild('sidenav') sideNav: MatSidenav;

	subsPageWizard: Subscription;
	subsDisplayWizard: Subscription;
	subsErrorPage: Subscription;

	routeSubscription: Subscription;

	isPositiveTheme: boolean = false;

	@Input() user: UserV3Model;
	@Input() isExternalUser: boolean;
	@Input() enableAcademy: boolean;
	@Input() isMyaldUser: boolean;
	@Input() isSystemUser: boolean;
	currentCommodity: CommodityModel;
	currentCommodities: CommodityModel[];
	currentprofileKey:string;

	modulesItemsMenu: ItemMenu[];
	profileItemsMenu: Map<NemoModuleKeys, ItemMenu[]> = new Map<NemoModuleKeys, ItemMenu[]>();
	staticItemsMenu: ItemMenu[];
	currentItemMenuID: string;

	currentCenterType: string;

	showLoader: boolean;
	loaderValue: boolean = false;
	isWebDealer: boolean;
	isOP: boolean;
	hiddenMenus: boolean;
	headerAbsUrl: string;
	footerAbsUrl: string;

	//V3 variable
	currentRoute: string;
	notificationCenterItemMenu: ItemMenu;
	totalUnreadAlert: number;
	totalUnreadNotification: number;

	reloaded: boolean = true;
	canSeeTooltip: boolean = false;

	translateContext: TranslateContext = TranslateContext.CORE;

	superUserInfoMessage: InPageMessage[] = [{
		type: InPageMessageType.INFO,
		size: InPageMessageSize.SMALL,
		text: this.translate.transform('UTENZA_IN_SOLA_LETTURA', this.translateContext),
	}];
	introMessage = '';

	get showSuperUserMessage(): boolean {
		return this.permissionService.getCurrentUserPermissions().isSuperUserByLocationPath(this.moduleService.getCurrentModule());
	}
	
	private amdLogoAnim: any;
	private amdMyaldLogoAnim: any;
	private currentPageWizard: string;
	private currentWebDealerOrderID: number;

	get isSelectCenterHidden(): boolean {
		const module: string = this.location.path().split('/')[1];
		let isValidRoute: boolean = true;
		switch (module) {
			case ROOT_MOBILITY: {
				const arr = [
					`/${ROOT_MOBILITY}/${MOBILITY_DASHBOARD}`,
					`/${ROOT_MOBILITY}/${MOBILITY_DASHBOARD}/${MOBILITY_DOSSIER_WORKING_LIST}`,
				];
				return (
					!this.permissionService.getCurrentUserPermissions().hasCurrentProfile(MOBILITY_MYMOBILITY_PROFILE_USER) ||
					!arr.includes(this.location.path())
				)
			}
			case ROOT_AUTHORITY:
				/**
				 * Show the select center component only if the current route is enabled and it is a center operator
				 */
				const arr = [
					`/${ROOT_AUTHORITY}/${AUTHORITY_DASHBOARD}`,
					`/${ROOT_AUTHORITY}/${AUTHORITY_DASHBOARD}/${AUTHORITY_DOSSIER_LIST}`,
					`/${ROOT_AUTHORITY}/${AUTHORITY_DASHBOARD}/${AUTHORITY_DOSSIER_WORKING_LIST}`,
					`/${ROOT_AUTHORITY}/${AUTHORITY_DASHBOARD}/${AUTHORITY_APPOINTMENTS_LIST}`,
				];
				isValidRoute = this.permissionService.getCurrentUserPermissions().isCenterOperator(NemoModuleKeys.AUTHORITY) && arr.includes(this.location.path());
				break;
			case ROOT_INVOICING:
				isValidRoute = this.currentRoute === `/${ROOT_INVOICING}/${INVOICING_DASHBOARD}` ||
					this.location.path() === `/${ROOT_INVOICING}/${INVOICING_TASKS}` ||
					this.location.path() === `/${ROOT_INVOICING}/${INVOICING_INVOICES}`;
				break;
			case ROOT_TYRES:
				const tyre_contract_detail: string = `/${ROOT_TYRES}/${TYRES_OPC}/${TYRES_OPC_DASHBOARD}/${TYRES_OPC_CONTRACTS}/${TYRES_OPC_CONTRACT_DETAIL}/`;
				isValidRoute = !(this.currentRoute.startsWith(tyre_contract_detail));
				break;
		}

		const currentProfile = this.permissionService.getCurrentUserPermissions().getCurrentProfile();
		this.currentprofileKey = currentProfile.key;

		if(currentProfile && currentProfile.type === 'ADMIN'){
			return true
		}
		else{
			let isSU: boolean = this.permissionService.getCurrentUserPermissions().isSuperUserByLocationPath(module);
			if(isSU){
				return (
						!this.permissionService.getCommoditiesFromItemMenuID(this.currentItemMenuID) || 
						!this.permissionService.getCommoditiesFromItemMenuID(this.currentItemMenuID).length || 
						!isValidRoute 
				)
			}
			return !this.currentCommodities || !this.currentCommodities.length || !isValidRoute;
		}
	}

	get isFilterCommoditiesByParent(): boolean {
		return this.location.path().startsWith(`/${ROOT_AUTHORITY}/`);
	}

	get isFullWidth(): boolean {
		return this.location.path().startsWith(`/${ROOT_AUTHORITY}/`) || this.location.path().startsWith(`/${ROOT_BOOKINGS}/`);
	}

	profile2Choice: ProfilePermissionModel[] = [];
	moduleName: string = '';
	showProfileDialog: boolean = false;
	isLocal: boolean = false;

	// tslint:disable-next-line:max-line-length
	constructor(
		public userV3Service: UserV3Service, public location: Location, private loaderService: LoaderService,
		private router: Router, private elRef: ElementRef, private deviceService: DeviceDetectorService, private constantsService: ConstantsService,
		private positiveThemeService: PositiveThemeService, protected wizardService: WizardService, @Inject(LOCALE_ID) locale: string, /*dateLocale: DateLocale,*/
		public dialog: MatDialog,
		private appConfig: AppConfigEnvironmentService,
		public errorPageService: ErrorPageService,
		public innerMessagesService: InnerMessagesService,
		public permissionService: PermissionService,
		private moduleService: ModuleService,
		private threadService: ThreadService,
		private translate: TranslatePipe,
		private notificationService: NotificationsService,
		private commoditiesUtilityService:CommoditiesUtilityService
	) {
			
		this.environmentLocation = appConfig.Environment.environment;
		this.environment = appConfig.Environment;
		this.currentRoute = this.location.path();
		this.checkPermissionForAcademy();
		this.checkPermissionForSearch();
		this.subscribePageWizard();
		this.subscribeDisplayWizard();
		this.subscribeErrorPage();
		//TODO setting
		this.currentCenterType = 'DELIVERY';
		Utilities.isLocalStorageNameSupported();
		this.detectDevice();

		this.monitoringRouting();
		//        this.startNotificationsPolling();
		this.loaderService.status_.subscribe(
			(val: boolean) => {
				this.loaderValue = val;
				if (val && (!Utilities.isVoid(this.amdLogoAnim) || !Utilities.isVoid(this.amdMyaldLogoAnim))) {
					if (this.isExternalUser) {
						this.amdMyaldLogoAnim.play();
					} else {
						this.amdLogoAnim.play();
					}
				}
				this.showLoader = val;
			});

			this.isLocal = this.environment.environment === 'local';

			/*
			 *	 Tooltip con i profili per ogni modulo
			 *
			 *   Probabilmente verrà scartata come idea
			 *   LO LASCIAMO SOLO PER IL LOCALE - ci semplifica la vita
			 *   ogni volta bisogna aprire il menù per selezionare un profilo...
			 */
			this.canSeeTooltip = this.isLocal;
			// this.canSeeTooltip = true;
	}

	ngOnInit(): void {

		// TODO - se il modulo del profilo corrente è diverso da quello dell'URL
		// da spostare, qui il profilo è stato già scelto (prendendo il primo in base al modulo)
		// const module = ModuleService.getCurrentModule();
		// if (module !== this.permissionService.getCurrentUserPermissions().getCurrentProfile().module.key) {
		// 	this.changeProfileByURL(module);
		// }
			
		//this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		//this.router.onSameUrlNavigation = 'reload';

		// rebranding Ayvens per flusso pubblico che torna dentro NEMO
		// this.rebranding(this.isSystemUser);
		
		if (this.isMyaldUser) {
			const metadata: MyaldMetadata = Utilities.getMetadata();
			if (metadata) {
				this.headerAbsUrl = metadata.header_url;
				this.footerAbsUrl = metadata.footer_url;
			}
		}

		if (this.permissionService.getCurrentUserPermissions().hasCrossPermission(CROSS_PERMISSION_NOTIFICATION_READER)) {
			this.threadService.startUnreadPolling(new NCStatsFilter()).subscribe(response => {
				this.totalUnreadAlert = response.stats.total_unread;
				this.setNotificationItemMenu();
			});
			this.notificationService.startUnreadNotificationPolling().subscribe(response => {
				this.totalUnreadNotification = response && response.length ? response.length : 0;
				this.setNotificationItemMenu();
			});
		}

		/**
		 * Imposta l'ItemMenuID corrente in base al modulo corrente
		 * aggiornando la pagina creava problemi al Super User, nella selezione centri
		 * 
		 * TODO
		 * togliere questa logica basata sugli ItemMenuID
		 * sostituirla con quella basata sui moduli - es. ModuleService.getCurrentModule()
		 */
		this.permissionService.setCurrentItemMenuId(this.permissionService.getModuleKeyFromMenu());

		if (this.permissionService.getCurrentUserPermissions().isSuperUserByLocationPath(this.moduleService.getCurrentModule())) {
			this.superUserRedirectToFindCenters(this.moduleService.getCurrentModule());
			return;
		}

		this.routeSubscription = this.router.events.subscribe(event => {
			if (event instanceof NavigationStart) {
				this.loaderService.display(true);
			}
			if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
				this.loaderService.display(false);
			}
		});

	}
	
	rebranding(isPublicFlux): void {

		const TITLE_REBRANDING_ALD = 'ALD | NEMO';
		const TITLE_REBRANDING_AYVENS = 'Ayvens | NEMO';

		const createIcon = (opt: any): HTMLLinkElement => {

			const link = document.createElement('link');
			Object.getOwnPropertyNames(opt).forEach(x => link[x] = opt[x]);
			return document.head.appendChild(link);			
		};
	
		const setIcon = (obj: any) => {
	
			const opt = { ...obj };
			delete opt.href;
			const queryStr = 'link' + Object.getOwnPropertyNames(opt).map(x => `[${x}="${opt[x]}"]`).reduce((x,y) => x + y);
			let link: HTMLLinkElement = document.querySelector(queryStr);
			
			if (!link) {
				link = createIcon(obj);
			}
			link.href = obj.href;

			// TEST rebranding
			// console.log(queryStr);
			// console.log(link);
		};
		
		const rebrandingALD = (): void => {
			
			document.title = TITLE_REBRANDING_ALD;
			const appleMobileWebAppTitle: any = document.querySelector("meta[name~='apple-mobile-web-app-title']");
			appleMobileWebAppTitle.content = TITLE_REBRANDING_ALD;
			const description: any = document.querySelector("meta[name~='description']");
			description.content = TITLE_REBRANDING_ALD;

			let link: HTMLLinkElement = document.querySelector("link[rel~='icon']");
			setIcon({href: '/assets/favicons/apple-touch-icon.png?v=1', rel: 'apple-touch-icon', sizes: '180x180', });
			setIcon({href: '/assets/favicons/favicon-32x32.png?v=1', rel: 'icon', sizes: '32x32', });
			setIcon({href: '/assets/favicons/favicon-16x16.png?v=1', rel: 'icon', sizes: '16x16', });
			setIcon({href: '/assets/favicons/site.webmanifest?v=1', rel: 'manifest', });
			setIcon({href: './favicon.ico', rel: 'shortcut icon', });
		};
		
		const rebrandingAyvens = (): void => {
			
			document.title = TITLE_REBRANDING_AYVENS;
			const appleMobileWebAppTitle: any = document.querySelector("meta[name~='apple-mobile-web-app-title']");
			appleMobileWebAppTitle.content = TITLE_REBRANDING_AYVENS;
			const description: any = document.querySelector("meta[name~='description']");
			description.content = TITLE_REBRANDING_AYVENS;
			
			setIcon({href: '/assets/images/branding/ayvens/favicon/apple-touch-icon.png?v=1', rel: 'apple-touch-icon', sizes: '180x180'});
			setIcon({href: '/assets/images/branding/ayvens/favicon/favicon-32x32.png?v=1', rel: 'icon', sizes: '32x32'});
			setIcon({href: '/assets/images/branding/ayvens/favicon/favicon-16x16.png?v=1', rel: 'icon', sizes: '16x16'});
			setIcon({href: '/assets/images/branding/ayvens/favicon/site.webmanifest?v=1', rel: 'manifest'});
			setIcon({href: '/assets/images/branding/ayvens/favicon/favicon.ico', rel: 'shortcut icon'});
		};

		isPublicFlux ? rebrandingAyvens() : rebrandingALD();

		// TEST rebranding
		// for(let i=0; i<document.querySelectorAll('link').length; i++) { console.log(document.querySelectorAll('link')[i]); }
		// for(let i=0; i<document.querySelectorAll('meta').length; i++) { console.log(document.querySelectorAll('meta')[i]); }
	}

	ngOnDestroy(): void {
		if (this.subsPageWizard) {
			this.subsPageWizard.unsubscribe();
		}
		if (this.subsErrorPage) {
			this.subsErrorPage.unsubscribe();
		}
		if(this.routeSubscription){
			this.routeSubscription.unsubscribe();
		}

		this.threadService.stopUnreadPolling();
		this.notificationService.stopUnreadNotificationPolling();
	}

	private checkPermissionForSearch(): void {
		this.enableSearch = this.permissionService.hasSearchPermission();
	}

	private checkPermissionForAcademy(): void {
		this.permissionService.getUserV3Permission().subscribe(
			(user: UserPermissionsModel) => {
				const cross: CrossPermissionModel[] = user.cross_permissions.filter(c => c.key === CoreComponent.ACADEMY);
				if (cross.length > 0) {
					this.enableAcademy = true;
				}
			}
		);
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.loaderManager();

		if (!Utilities.isVoid(changes.user) && !Utilities.isVoid(changes.user.currentValue)) {
			this.user = changes.user.currentValue;
			this.setIntroMessage(this.user);
			this.modulesItemsMenu = this.permissionService.getCurrentUserPermissions().getModulesItemsMenu()(true);
			this.modulesItemsMenu.sort( (a,b) => this.translate.transform(a.module_key, this.translateContext).localeCompare(this.translate.transform(b.module_key, this.translateContext)));
			/*
			this.modulesItemsMenu = this.modulesItemsMenu.map(itemMenu => {
				itemMenu.profile_key = this.getProfileListByModule(itemMenu.module_key)[0].key;
				return itemMenu;
			});*/

			// ---------------------------------------------------------------------------------------------------
			
			// itemMenu per tutti i profili
			const allItemMenuList: ItemMenu[] = this.permissionService.getCurrentUserPermissions().getModulesItemsMenu()(false);

			// Per ogni modulo, creare una Map e creare un ItemMenu per i profili associati
			Object.keys(NemoModuleKeys).forEach(x => {

				const module = NemoModuleKeys[x];
				const profileList: ItemMenu[] = allItemMenuList.filter(z => z.module_key === module);
				if(profileList.length > 0){
					this.profileItemsMenu.set(module, profileList);
				}
			});

			this.notificationCenterItemMenu = this.permissionService.getCurrentUserPermissions().getNotificationCenterItemMenu();
			this.staticItemsMenu = this.permissionService.getCurrentUserPermissions().getStaticItemsMenu();
			this.isPositiveTheme = this.userV3Service.getTemplate() === 0;
			this.constantsService.setIsPositiveTheme(this.isPositiveTheme);
			this.positiveThemeService.setIsPositiveTheme(this.isPositiveTheme);
			this.handlerRouteChange();
		}
	}

	getProfileListByModule(module: NemoModuleKeys): ProfilePermissionModel[] {
		return this.permissionService.getCurrentUserPermissions().getProfileListByModule(module);
	}

	setIntroMessage(user: UserV3Model): void {
		
		this.introMessage = '<div class="introjs-head"><p><i class="amd-icon amd-icon--welcome"></i></p><h3>'+ 
												this.translate.transform('BENVENUTO_SU_NEMO', this.translateContext) +
												'</h3></div><div class="introjs-content">'+
												this.translate.transform('BENVENUTO_SU_NEMO', this.translateContext) + ' <b>' +
												user.personal_details.firstname + ' ' + 
												user.personal_details.lastname + '</b>, '+ 
												this.translate.transform('PER_AGEVOLARE_IL_TUO_LAVORO', this.translateContext) + '</div>'
											;
	}

	setDateLocale(dateLocale: any, locale: string): void {
		DateUtilities.setDateLocale(dateLocale, locale);
	}

	detectDevice(): void {
		this.deviceInfo = this.deviceService.getDeviceInfo();
	}

	private loaderManager(): void {

		// loader params
		const elementId: string = 'amd-loader-id';
		const myaldElementId: string = 'amd-myald-loader-id';

		const amdLogoParams: LogoParams = {
			container: document.getElementById(elementId),
			renderer: 'svg',
			loop: true,
			autoplay: true,
			path: '/assets/logo.animation.json'
		};

		const amdMyaldLogoParams: LogoParams = {
			container: document.getElementById(myaldElementId),
			renderer: 'svg',
			loop: true,
			autoplay: true,
			path: '/assets/myald.animation.json'
		};

		if (!this.isExternalUser) {
			this.amdLogoAnim = bodymovin.loadAnimation(amdLogoParams);
			this.amdLogoAnim.setSpeed(1.1);
			this.amdLogoAnim.addEventListener('loopComplete',
				() => {
					if (!this.loaderValue) {
						this.showLoader = this.loaderValue;
						this.amdLogoAnim.stop();
					}
				});
		} else {
			this.amdMyaldLogoAnim = bodymovin.loadAnimation(amdMyaldLogoParams);
			//this.amdMyaldLogoAnim.setSpeed(0.5);
			this.amdMyaldLogoAnim.addEventListener('loopComplete',
				() => {
					if (!this.loaderValue) {
						this.showLoader = this.loaderValue;
						this.amdMyaldLogoAnim.stop();
					}
				});
		}
	}

	goToUserHome(): void {
		this.router.navigate(['/']);
	}

	changeProfileByURL(moduleByURL: Module): void {
			
			// escludere il Module.PROFILE
			const profile = this.permissionService.getCurrentUserPermissions();
			
			// l'utente ha un profilo associato al modulo in questione
			// const profileList: ProfilePermissionModel[] = profile.getCurrentProfileList().filter(x => x.module.key === moduleByURL);
			const profileList: ProfilePermissionModel[] = profile.getProfileList().filter(x => x.module.key === moduleByURL);

			// non dovrebbe verificarsi questo caso d'uso
			if (Utilities.isEmpty(profileList)) {
				return;
			}

			// se si cambia modulo
			if (profile.getCurrentProfile().module.key !== moduleByURL) {
					
				// cambio diretto - abbiamo solo 1 profilo associato al modulo
				if (profileList.length === 1) {
					
					// if(profileList[0].key){
					// c'è 1 solo profilo current per ogni modulo
					const profileFound = profileList.find(x => !!x.current);
					if (profileFound.key) {
					this.loaderService.display(true);
						this.permissionService.updateCurrentProfile(this.userV3Service.getCurrentUser().id, profileFound.key).subscribe(res => {
							profile.setCurrentProfile(profileFound.key);
							this.loaderService.display(false);
						});
					}
					return;
				}
	
				// TODO gestione con la dialog
				// può avere la necessità di cambiare profilo anche se non si cambia modulo
				if (profileList.length > 1 && this.isLocal) {
					this.profile2Choice = profileList;
					this.moduleName = moduleByURL;
					this.showProfileDialog = true;
				}
			}
	};

	setCurrentProfile(x: ProfilePermissionModel): void {
		this.permissionService.updateCurrentProfile(this.userV3Service.getCurrentUser().id, x.key).subscribe(res => {
			this.permissionService.getCurrentUserPermissions().setCurrentProfile(x.key);
		});
		this.showProfileDialog = false;
	}

	monitoringRouting(): void {
		this.router.events.filter(event => event instanceof NavigationEnd).subscribe(event => {

			// cambiare il current_profile in base al modulo dell'URL
			//this.changeProfileByURL(ModuleService.getCurrentModule());

			Utilities.scrollUp($);
			this.currentRoute = (event as NavigationEnd).url;
			if (!Utilities.isVoid(this.user)) {
				this.handlerRouteChange();
			}
		});
	}

	handlerRouteChange(): void {
		this.setItemMenu();
		if (!Utilities.isVoid(this.user) && !this.isWebDealer &&
			!Utilities.isVoid(this.currentRoute) && this.currentRoute.endsWith('/dashboard')) {
			this.showAddToHome();
		}
	}

	private setItemMenu(): void {
		const newCurrentItemMenuID: string = get_current_item_menu_id(this.location, this.permissionService);


				

		if (this.currentItemMenuID !== newCurrentItemMenuID) {
			this.currentItemMenuID = newCurrentItemMenuID;
			//this.currentprofileKey = this.modulesItemsMenu.find(item => item.id == this.currentItemMenuID) ? this.modulesItemsMenu.find(item => item.id == this.currentItemMenuID).profile_key : ''
			this.setCurrentCommodities();
		}

		this.hiddenMenus =
			this.currentRoute.startsWith('/' + ROOT_DIGITAL_SIGN) ||
			this.currentRoute.includes(UC_SIGN) ||
			this.currentRoute.includes(AUTHORITY_DOSSIER_SIGN) ||
			this.currentRoute.includes(ROOT_VERSION) ||
			this.currentRoute.includes(BookingsRoutingRoots.SIGN);

		if (this.hiddenMenus) {
			this.currentItemMenuID = '-1';
		}
//		this.permissionService.setCurrentItemMenuId(this.currentItemMenuID);
//		this.permissionService.setCurrentItemMenuProfileKey(this.currentprofileKey);
//		this.permissionService.getCurrentUserPermissions().profileKey = this.currentprofileKey;
	}

	private showAddToHome(): void {
		if (!Utilities.isVoid(this.user)) {
			const isDashboardViewed: boolean = this.userV3Service.isPageAccessed(WizardSteps.DELIVERY_DASHBOARD);
			if (!this.isFirstLogin && isDashboardViewed && !this.userV3Service.getNotShowAddToHome()) {
				const chromeOnAndroid: boolean = (this.deviceService.browser === 'chrome' || this.deviceService.browser === 'firefox')
					&& this.deviceService.os === 'android';
				const safariOnMac: boolean = (this.deviceService.os === 'mac' || this.deviceService.os === 'ios')
					&& this.deviceService.browser === 'safari';

				if ((this.deviceService.isTablet() && safariOnMac) || chromeOnAndroid) {
					this.openAddToHomeDialog(this.deviceService.browser);
				}
			}
		}
	}

	private subscribeDisplayWizard(): void {
		this.subsDisplayWizard = this.wizardService.display_wizard.subscribe(
			res => {
				if (res) {
					this.startIntro(true);
				}
			});
	}

	private subscribePageWizard(): void {
		this.subsPageWizard = this.wizardService.page_wizard.subscribe(
			res => {
				this.currentPageWizard = res;
				if (!Utilities.isVoid(this.user) && !Utilities.isVoid(this.currentPageWizard)) {
					this.checkAccessedPageAndStartIntro(this.currentPageWizard);
				}
			});
	}

	private subscribeErrorPage(): void {
		this.subsErrorPage = this.errorPageService.errorPageObservable.subscribe(
			res => {
				this.currentErrorPage = res;
			});
	}

	changeTheme($event: any): void {
		this.isPositiveTheme = !this.isPositiveTheme;
		const levels: string[] = [UserV3CustomDataModel.LEVEL_APP_SETTINGS, UserV3CustomDataModel.LEVEL_TEMPLATE];
		const body: { value: number } = {
			value: this.isPositiveTheme ? 0 : 1
		};
		this.constantsService.setIsPositiveTheme(this.isPositiveTheme);
		this.positiveThemeService.setIsPositiveTheme(this.isPositiveTheme);
		this.userV3Service.setCustomData(levels, body).pipe(take(1)).subscribe();
	}

	onHideBannerEvent(event: boolean): void {
		this.isFirstLogin = !event;
	}

	// jQuery andrebbe tolto! 
	// appesantisce inutilmente il progetto

	itemMenuEnterListener(event: any): void {
		// non ci vuole molto per eliminare jQuery...
		this.isMenuWrapperClosed = false;
	}

	itemMenuLeaveListener(event: any): void {
		// non ci vuole molto per eliminare jQuery...
		// Se la sidenav è aperta, la sezione dei profili non si deve chiudere
		this.isMenuWrapperClosed = this.isSidenavClosed && true;
	}

	onOpenNav(): void {
		this.isSidenavClosed = false;
		this.isMenuWrapperClosed = false;

		$('.mat-sidenav-content').attr('style', 'margin-left: 250px;transform: translate3d(0, 0, 0)');

		$('.mat-sidenav').removeClass('mat-sidenav-closed').addClass('mat-sidenav-opening');
		$('.mat-sidenav').addClass('custom-sidnav-with');

	}

	onCloseNav(): void {
		this.isSidenavClosed = true;
		this.isMenuWrapperClosed = true;

		$('.mat-sidenav-content').removeAttr('style');

		$('.mat-sidenav').removeClass('mat-sidenav-opening custom-sidnav-with').addClass('mat-sidenav-closed');
		$('.mat-sidenav').removeClass('custom-sidnav-with')
	}

	onClickLogout(event: any): void {
		this.openLogoutDialog();
	}

	openLogoutDialog(): void {
		this.dialog.open(LogoutDialogComponent, {
			height: 'auto',
			width: '600px'
		});
	}

	openAddToHomeDialog(browser: string): void {
		const dialogRef: MatDialogRef<any> = this.dialog.open(AddToHomeDialogComponent, {
			height: 'auto',
			panelClass: 'add-to-home-dialog',
			width: '300px',
			position: {top: '100px'}
		});
		dialogRef.componentInstance.browser = browser;
		dialogRef.afterClosed().subscribe(result => {
			if (!Utilities.isVoid(result) && result) {
				const levels: string[] = [UserV3CustomDataModel.LEVEL_APP_SETTINGS, UserV3CustomDataModel.LEVEL_NOT_SHOW_ADD_TO_HOME];
				const body: { value: any } = {
					value: result
				};
				this.userV3Service.setCustomData(levels, body).subscribe();
			}
		});
	}

	openSearchDialog(event: any): void {
		const dialogRef: MatDialogRef<SearchDialogComponent, any> = this.dialog.open(SearchDialogComponent, {
			width: '680px',
			height: 'auto'
		});
		dialogRef.afterClosed().subscribe(
			c => {
				if (c === SearchDialogComponent.CLOSE_RESEARCH_START) {
					this.currentItemMenuID = this.deliveryItemMenuID;
				}
				this.onCloseNav();
			}
		);
	}


	checkAccessedPageAndStartIntro(page: string): void {
		if (!this.userV3Service.isPageAccessed(page)) {
			this.startIntro(false);
			this.setAccessedPageUserPreference(page);
		}
	}

	setAccessedPageUserPreference(page: string): void {
		this.userV3Service.addAccessedPage(page);
		const levels: string[] = [UserV3CustomDataModel.LEVEL_APP_SETTINGS, UserV3CustomDataModel.LEVEL_ACCESSED_PAGES];
		const body: { value: string[] } = {
			value: this.userV3Service.getAccessedPages()
		};
		this.userV3Service.setCustomData(levels, body).subscribe();
	}

	startIntro(isSkippable: boolean): void {

		const steps: any = WizardSteps.getSteps(this.currentPageWizard);

		$('.mat-sidenav-content').animate({scrollTop: -20}, 50, function (): void {
			$('.amd-page').css({position: 'static'});
		});


		this.intro = introJs.introJs().setOptions({
			'showStepNumbers': false,
			'overlayOpacity': 1,
			'disableInteraction': true,
			'showBullets': false,
			'doneLabel': 'Fine',
			'skipLabel': '',
			'nextLabel': 'Avanti',
			'prevLabel': 'Indietro',
			'exitOnOverlayClick': isSkippable,
			'exitOnEsc': isSkippable
		});

		if (isSkippable) {
			this.intro.setOption('skipLabel', 'Termina');
		}

		if (!Utilities.isVoid(steps) && !this.isWebDealer) {

			if (this.isFirstLogin && this.currentPageWizard === WizardSteps.DELIVERY_DASHBOARD) {
				this.intro.addStep({
					intro: this.introMessage,
					tooltipClass: 'introjs-tooltip--welcome'
				});
			}

			this.intro.addSteps(steps);
			this.intro.start();

			this.intro.oncomplete(function (): void {
				$('.amd-page').css({position: ''});
			});
			this.intro.onexit(function (): void {
				$('.amd-page').css({position: ''});
			});
		}
	}

	redirectToAcademy(): void {
		const redirectUriAcademy: string = this.environment.ENTRY_POINT_E_LEARNING;
		Utilities.redirectToUri(redirectUriAcademy);
	}

	onCLickItemMenu(item: ItemMenu): void {
		if(item.profile_key){
			this.loaderService.display(true);
			this.reloaded = false; // nasconde menu header in alto a destra
			this.permissionService.updateCurrentProfile(this.userV3Service.getCurrentUser().id, item.profile_key).subscribe(
				(res) => {
					this.permissionService.refreshMultiProfileUserPermissions(res, item.profile_key, item.id).subscribe((res) => { // aggiorna l'utente e i profili dopo aver selezinato un nuovo profilo corrente
						
						this.loaderService.display(true);
						this.setCurrentCommodities();
						//this.permissionService.setCurrentItemMenuId(item.id);
						//this.permissionService.getCurrentUserPermissions().setProfilePermission(item.profile_key);
						this.currentprofileKey = item.profile_key;
						this.reloaded = true;
						this.onCloseNav();
						//this.router.onSameUrlNavigation = 'reload';
						this.router.navigate([item.routerLink]/*,{ replaceUrl: true }*/).then(() => {
							this.loaderService.display(false);
						});
				},
				(err) => {
					this.loaderService.display(false);
				}
			)}
			)
			/*
			this.permissionService.updateCurrentProfile(this.userV3Service.getCurrentUser().id, item.profile_key).subscribe( // aggiorna profilo current del modulo selezionto
					(res) => {
						this.permissionService.refreshV3Permission(item.profile_key, item.id).subscribe((refreshRes)=> {// aggiorna l'utente e i profili dopo aver selezinato un nuovo profilo corrente
							this.loaderService.display(true);
							this.reloaded = true;
							this.setCurrentCommodities();
							this.permissionService.setCurrentItemMenuId(item.id);
							this.permissionService.getCurrentUserPermissions().setProfilePermission(item.profile_key);
							this.currentprofileKey = item.profile_key;
							this.onCloseNav();
							this.router.onSameUrlNavigation = 'reload';
							this.router.navigate([item.routerLink],{ replaceUrl: true }).then(() => {
								this.loaderService.display(false);
								
							});
						});
						
					},
					(err) => {
		
					}
				)
			*/		
			}
			else{
				this.loaderService.display(true);
				this.reloaded = false; // nasconde menu header in alto a destra
				this.loaderService.display(true);
				this.reloaded = true;
				this.setCurrentCommodities();
				this.permissionService.setCurrentItemMenuId(item.id);
				this.permissionService.getCurrentUserPermissions().setProfilePermission(item.profile_key);
				this.currentprofileKey = item.profile_key;
				this.onCloseNav();
				this.router.onSameUrlNavigation = 'reload';
				this.router.navigate([item.routerLink],{ replaceUrl: true }).then(() => {
					this.loaderService.display(false);
					
				});
			}
		}


	private setCurrentCommodities(): void {
		this.currentCommodities = this.permissionService.getCommoditiesFromItemMenuID(this.currentItemMenuID);
		if(this.currentCommodities && this.currentCommodities.length > 0)
			this.commoditiesUtilityService.currentCommodities = this.currentCommodities.filter(c => c.ald_commodity_id !== CommodityModel.allCentersID);
		this.commoditiesUtilityService.multiCommodities = this.isAllowsMultiCommodities();
	}

	isAllowsMultiCommodities(): boolean {
		let currentModule = this.location.path().split('/')[1];
		if(currentModule === 'authority') {
			 return this.permissionService.getCurrentUserPermissions().hasProfile(['authority_leader_dealer']);
		} else {

			let keys = Object.keys(NemoModuleKeys).filter(x => NemoModuleKeys[x] == currentModule);
			let result =  (keys && keys.length > 0) ? keys[0] : null;
			if(result){
				return this.permissionService.getCurrentUserPermissions().isCenterOperator(NemoModuleKeys[result]);
			}
		}			
		return false;
	}

	// TODO
	// Eliminare perché è inutile
	// le landing page dei profili sono mappate in modules-loading.guard.ts
	private superUserRedirectToFindCenters(currentModule: Module): void {
		let url: string;
		switch (currentModule) {
			case Module.USER_CHANGE :
				url = ROOT_USER_CHANGE_SP;
				break;
			case Module.TYRES :
				url = `${ROOT_TYRES}/${TYRES_OPC}`;
				break;
			case Module.CONTRACT_CLOSING :
				url = ROOT_CONTRACT_CLOSING_SP;
				break;
			case Module.LOGISTICS :
				url = `${ROOT_LOGISTICS}/${LOGISTICS_OPASR}`;
				break;
			default:
				url = currentModule;
		}
		// //Se siamo su authority la pagina iniziale è sempre quella del tab pratiche
		// if(currentModule == Module.AUTHORITY){
		// 	this.router.navigate([url, "dashboard", "dossier-workings"]).then(() => this.loaderService.display(false));
		// }
		// else{
			this.router.navigate([`${url}/${FIND_CENTERS_DASHBOARD}`]).then(() => this.loaderService.display(false));
		// }
	}

	private setNotificationItemMenu(): void {
		this.notificationCenterItemMenu.icon = (this.totalUnreadAlert + this.totalUnreadNotification) !== 0 ? 'amd-icon--font amd-icon--alertNotifica-32x32' : 'amd-icon--font amd-icon--alert-32x32';
		this.notificationCenterItemMenu.count = this.totalUnreadAlert + this.totalUnreadNotification;
	}
}
